/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { GDPRConsentResponse } from './GDPRConsentResponse';
import {
    GDPRConsentResponseFromJSON,
    GDPRConsentResponseFromJSONTyped,
    GDPRConsentResponseToJSON,
} from './GDPRConsentResponse';

/**
 * 
 * @export
 * @interface GetConsentGdpr200Response
 */
export interface GetConsentGdpr200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetConsentGdpr200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetConsentGdpr200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {GDPRConsentResponse}
     * @memberof GetConsentGdpr200Response
     */
    result?: GDPRConsentResponse;
}

/**
 * Check if a given object implements the GetConsentGdpr200Response interface.
 */
export function instanceOfGetConsentGdpr200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetConsentGdpr200ResponseFromJSON(json: any): GetConsentGdpr200Response {
    return GetConsentGdpr200ResponseFromJSONTyped(json, false);
}

export function GetConsentGdpr200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConsentGdpr200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : GDPRConsentResponseFromJSON(json['result']),
    };
}

export function GetConsentGdpr200ResponseToJSON(value?: GetConsentGdpr200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': GDPRConsentResponseToJSON(value.result),
    };
}

